import React, { useEffect, useState } from 'react';

const BULLET_HOLE_DURATION_MS = 2000;

const BulletHoleEffect = () => {
  const [bulletHoles, setBulletHoles] = useState([]);

  useEffect(() => {
    const handleClick = (e) => {
      // Check if clicked element is interactive
      const target = e.target;
      const isInteractive = 
        target.tagName === 'BUTTON' ||
        target.tagName === 'A' ||
        target.closest('button') ||
        target.closest('a') ||
        target.onclick ||
        target.style.cursor === 'pointer' ||
        window.getComputedStyle(target).cursor === 'pointer';

      if (isInteractive) {
        const id = Date.now();
        const newHole = {
          id,
          x: e.clientX,
          y: e.clientY
        };

        setBulletHoles(prev => [...prev, newHole]);

        // Remove bullet hole after duration
        setTimeout(() => {
          setBulletHoles(prev => prev.filter(hole => hole.id !== id));
        }, BULLET_HOLE_DURATION_MS);
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps intentional: mount-only effect for event listeners

  return (
    <>
      {bulletHoles.map(hole => (
        <div
          key={hole.id}
          className="fixed pointer-events-none z-[100]"
          style={{
            left: hole.x,
            top: hole.y,
            transform: 'translate(-50%, -50%)'
          }}
        >
          {/* Bullet hole with impact effect */}
          <svg width="40" height="40" viewBox="0 0 40 40" className="animate-bullet-impact">
            {/* Outer impact cracks */}
            <g opacity="0.6">
              <line x1="20" y1="20" x2="8" y2="8" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="1" />
              <line x1="20" y1="20" x2="32" y2="8" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="1" />
              <line x1="20" y1="20" x2="32" y2="32" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="1" />
              <line x1="20" y1="20" x2="8" y2="32" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="1" />
              <line x1="20" y1="20" x2="20" y2="5" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="0.8" />
              <line x1="20" y1="20" x2="35" y2="20" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="0.8" />
              <line x1="20" y1="20" x2="20" y2="35" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="0.8" />
              <line x1="20" y1="20" x2="5" y2="20" stroke="rgba(50, 50, 50, 0.8)" strokeWidth="0.8" />
            </g>
            
            {/* Main bullet hole */}
            <circle cx="20" cy="20" r="6" fill="rgba(30, 30, 30, 0.9)" />
            <circle cx="20" cy="20" r="4" fill="rgba(10, 10, 10, 0.95)" />
            
            {/* Hole depth effect */}
            <circle cx="19" cy="19" r="2" fill="rgba(0, 0, 0, 1)" />
            
            {/* Highlight */}
            <ellipse cx="21" cy="21" rx="1.5" ry="1" fill="rgba(60, 60, 60, 0.6)" />
          </svg>

          {/* Impact flash */}
          <div className="absolute inset-0 -m-4">
            <div className="w-12 h-12 rounded-full bg-red-600 opacity-50 animate-impact-flash" />
          </div>
        </div>
      ))}
    </>
  );
};

export default BulletHoleEffect;
